import { delay } from "../client.js";

export const ALBIN_PERMISSIONS = [
  "accountsettings.account.create",
  "accountsettings.account.delete",
  "accountsettings.account.listall",
  "accountsettings.account.update",
  "accountsettings.account.view",
  "accountsettings.device.create",
  "accountsettings.device.delete",
  "accountsettings.device.listall",
  "accountsettings.device.update",
  "accountsettings.device.view",
  "accountsettings.role.create",
  "accountsettings.role.delete",
  "accountsettings.role.listall",
  "accountsettings.role.update",
  "accountsettings.role.view",
  "accountsettings.user.create",
  "accountsettings.user.delete",
  "accountsettings.user.listall",
  "accountsettings.user.update",
  "accountsettings.user.view",
  "accountsettings.user.viewperm",
  "accountsettings.user.updateperm",
  "accountsettings.invitation.create",
  "accountsettings.invitation.listall",
  "all.all.all",
];

export const MOCK_USERS = [
  { id: "usr-1", name: "Albin CR", email: "albin@intellicar.in", status: "active" },
  { id: "usr-2", name: "Sakthi Lingaguru", email: "sakthi@intellicar.in", status: "active" },
  { id: "usr-3", name: "Sonal Pachpute", email: "sonal@intellicar.in", status: "active" },
  { id: "usr-4", name: "Aman Gandhi", email: "aman@intellicar.in", status: "active" },
  { id: "usr-5", name: "Akash Rampure", email: "akash@intellicar.in", status: "active" },
  { id: "usr-6", name: "Karan Aneja", email: "karan@intellicar.in", status: "active" },
  { id: "usr-7", name: "Debnath Mondal", email: "debnath@intellicar.in", status: "active" },
  { id: "usr-8", name: "Rinoy K", email: "rinoy@intellicar.in", status: "active" },
  { id: "usr-9", name: "Saksham Tulani", email: "saksham@intellicar.in", status: "active" },
  { id: "usr-10", name: "Chirag Kumar", email: "chirag@intellicar.in", status: "active" },
  { id: "usr-11", name: "Ayush Mhaskar", email: "ayush@intellicar.in", status: "active" },
  { id: "usr-12", name: "Joseph MJ", email: "joseph@intellicar.in", status: "active" },
  { id: "usr-13", name: "Test User", email: "test@intellicar.in", status: "inactive" },
  { id: "usr-14", name: "Kartik Thakur", email: "kartik@intellicar.in", status: "active" },
  { id: "usr-15", name: "Rohit Srivastava", email: "rohit@intellicar.in", status: "active" },
];

export const MOCK_USER_PERMISSIONS = {
  "usr-1": [...ALBIN_PERMISSIONS],
  "usr-2": ["accountsettings.user.view", "accountsettings.device.view"],
  "usr-3": ["accountsettings.user.view"],
  "usr-4": ["accountsettings.device.view", "accountsettings.device.listall"],
  "usr-5": ["accountsettings.role.view"],
  "usr-6": ["accountsettings.user.view", "accountsettings.account.view"],
  "usr-7": ["accountsettings.user.create", "accountsettings.user.update"],
  "usr-8": ["accountsettings.device.view"],
  "usr-9": ["accountsettings.invitation.create"],
  "usr-10": ["accountsettings.role.view", "accountsettings.role.listall"],
  "usr-11": ["accountsettings.user.view"],
  "usr-12": ["accountsettings.account.view"],
  "usr-13": [],
  "usr-14": ["accountsettings.device.view", "accountsettings.user.view"],
  "usr-15": ["accountsettings.user.view", "accountsettings.role.view"],
};

export const AVAILABLE_PERMISSIONS = [
  ...ALBIN_PERMISSIONS,
  "accountsettings.invitation.delete",
  "accountsettings.invitation.view",
  "fleetmanagement.vehicle.view",
  "fleetmanagement.vehicle.create",
];

export async function listUsers() {
  await delay(160);
  return [...MOCK_USERS];
}

export async function listUserPermissions(userId) {
  await delay(80);
  return [...(MOCK_USER_PERMISSIONS[userId] ?? [])];
}

export async function updateUserStatus(userId, status) {
  await delay(120);
  const user = MOCK_USERS.find((u) => u.id === userId);
  if (!user) throw new Error("User not found");
  user.status = status;
  return { ...user };
}

export async function updateUserPermissions(userId, permissions) {
  await delay(100);
  MOCK_USER_PERMISSIONS[userId] = [...permissions];
  return [...permissions];
}
